import React, { useEffect, useReducer } from 'react'
import BodyCard from '@/Components/BodyCard'
import HeaderCard from '@/Components/HeaderCard'
import TextLabel from '@/Components/Common/TextLabel'
import { useLoaderData, useNavigate } from 'react-router-dom'
import { Checkbox } from '@/Components/ui/checkbox'
import SearchableDropdown from '@/Components/Common/SearchableDropdown'
import { Button } from '@/Components/ui/button'
import { toast } from 'react-toastify'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/Components/ui/table'
import NoDataFound from '@/Components/Common/NoDataFound'
import WMSSettingsService from '@/Service/WMSSettingsService'

const WmsSettings = () => {
    const { roles, wmsSettings } = useLoaderData()
    const navigate = useNavigate()
    const [event, updateEvent] = useReducer(
        (prev, next) => {
            if (next?.isAllRoleRowsChecked !== undefined) {
                prev.wmsRoles = prev.wmsRoles.map((role) => {
                    role['checkbox'] = next.isAllRoleRowsChecked
                    return role
                })
            }
            return { ...prev, ...next }
        },
        {
            isAllRoleRowsChecked: false,
            isSaving: false,
            wmsRoles: [],
        }
    )

    useEffect(() => {
        updateEvent({
            wmsRoles : wmsSettings?.wms_roles_table.map((role,i) => {
                return {
                    id : i + 1,
                    checkbox : false,
                    roles : role.roles
                }
            })
        })
    } ,[wmsSettings])

    const handleSaveClick = async () => {
        try {
            if (event.wmsRoles.some((val) => val.roles == '')) {
                toast.error('Role is required')
                return
            }
            let postRequest = {
                wms_roles: event.wmsRoles,
            }
            const settings = await WMSSettingsService.addWmsSettings(postRequest)
            if(settings.data.success){
                console.log("dsd");
                navigate(".", {replace : true})
            }
        } catch {}
    }

    console.log("rols", event.wmsRoles)
    return (
        <>
            <HeaderCard>
                <div className="flex items-center justify-end gap-2">
                    <Button
                        className="bg-primary-purpal hover:bg-primary-purpal px-4"
                        onClick={handleSaveClick}
                        iconType="Save"
                        disabled={event.isSaving}
                    >
                        Save {event.isSaving && <Loader fullScreen={false} />}
                    </Button>
                </div>
            </HeaderCard>
            <BodyCard>
                <div className="grid grid-cols-2 gap-y-2 gap-x-6">
                    <div>
                        <TextLabel required={true} text="Roles" />
                        <Table className="mt-2">
                            <TableHeader>
                                <TableRow className="border">
                                    <TableHead className="w-[10%] border">
                                        <Checkbox
                                            checked={event.isAllRoleRowsChecked}
                                            onCheckedChange={(isChecked) => {
                                                updateEvent({ isAllRoleRowsChecked: isChecked })
                                            }}
                                        />
                                    </TableHead>
                                    <TableHead className="w-[10%] border">Sr.No</TableHead>
                                    <TableHead className="w-[80%] border">Roles</TableHead>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {event.wmsRoles.length == 0 ? (
                                    <TableRow key="noDataFound" className="border">
                                        <TableCell className="border" colSpan="6">
                                            <NoDataFound />
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    event.wmsRoles.map((row, currentIndex) => (
                                        <TableRow
                                            key={currentIndex}
                                            className="border"
                                            onKeyDown={(e) => {
                                                if (e.key == 'Tab' && currentIndex == event.wmsRoles.length - 1 && event.wmsRoles[event.wmsRoles.length-1]['roles'] !== '') {
                                                    updateEvent({
                                                        wmsRoles: [
                                                            ...event.wmsRoles,
                                                            {
                                                                id: event.wmsRoles.length == 0 ? 1 : event.wmsRoles[event.wmsRoles.length - 1]['id'] + 1,
                                                                roles: '',
                                                                checkbox: false,
                                                            },
                                                        ],
                                                    })
                                                }
                                            }}
                                        >
                                            <TableCell className="border">
                                                <Checkbox
                                                    onCheckedChange={(isChecked) =>
                                                        updateEvent({
                                                            wmsRoles: event.wmsRoles.map((roles, i) => {
                                                                if (i == currentIndex) {
                                                                    roles['checkbox'] = isChecked
                                                                }
                                                                return roles
                                                            }),
                                                        })
                                                    }
                                                    checked={row.checkbox}
                                                    value={row.checkbox}
                                                />
                                            </TableCell>
                                            <TableCell className="border">{parseInt(1 + currentIndex)}</TableCell>

                                            <TableCell className="border px-0">
                                                <SearchableDropdown
                                                    selectedVal={row.roles}
                                                    options={roles}
                                                    label="role_name"
                                                    handleChange={(val) => {
                                                        if (val !== '' && event.wmsRoles.some((role) => role.roles == val)) {
                                                            toast.warn(`You have already selected the '${val}' role. Please choose a different role.`)
                                                            return
                                                        }
                                                        updateEvent({
                                                            wmsRoles: event.wmsRoles.map((roles, i) => {
                                                                console.log('val ', val)
                                                                if (i == currentIndex) {
                                                                    roles['roles'] = val
                                                                }
                                                                return roles
                                                            }),
                                                        })
                                                    }}
                                                    className="border-none w-full outline-none ring-0 focus-visible:ring-0"
                                                    placeholder="Roles"
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                        <div className="mt-2 flex gap-1">
                            <Button
                                type="button"
                                onClick={() =>
                                    updateEvent({
                                        wmsRoles: [
                                            ...event.wmsRoles,
                                            {
                                                id: event.wmsRoles.length == 0 ? 1 : event.wmsRoles[event.wmsRoles.length - 1]['id'] + 1,
                                                roles: '',
                                                checkbox: false,
                                            },
                                        ],
                                    })
                                }
                                className=" hover:bg-gray-200 bg-gray-200 border-gray-800 text-gray-600 text-[12px]"
                            >
                                Add Row
                            </Button>

                            {event.wmsRoles.length > 0 && !event.isAllRoleRowsChecked && event.wmsRoles.filter((row) => row.checkbox).length > 0 && (
                                <Button
                                    type="button"
                                    className="bg-primary-red ml-1 font-normal"
                                    onClick={() =>
                                        updateEvent({
                                            wmsRoles: event.wmsRoles.filter((roles) => !roles.checkbox),
                                        })
                                    }
                                >
                                    Delete
                                </Button>
                            )}
                            {event.wmsRoles.length > 0 && event.isAllRoleRowsChecked && (
                                <Button
                                    type="button"
                                    className="bg-primary-red ml-1 font-normal"
                                    onClick={() =>
                                        updateEvent({ isAllRoleRowsChecked : false, wmsRoles: [] })
                                    }
                                >
                                    Delete All
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            </BodyCard>
        </>
    )
}

export default WmsSettings
